import { binToNumberUintLE, binToNumberUint16LE, binToNumberUint32LE, numberToBinUint16LE, numberToBinUint32LE, hexToBin } from "@bitauth/libauth";
import { catUint8 } from "./util.js";
export function decodePushByte(data) {
    if (typeof data === "string")
        data = hexToBin(data);
    if (data.length == 0) {
        return [Uint8Array.of(0), 0];
    }
    const radix = data[0];
    if (radix === 0) {
        return [Uint8Array.from([]), 1];
    }
    else if (radix >= 80 /* PushOperationConstants.pushNumberOpcodesOffset */
        && radix <= 80 /* PushOperationConstants.pushNumberOpcodesOffset */ + 16 /* PushOperationConstants.pushNumberOpcodes */) {
        return [Uint8Array.of(radix - 80 /* PushOperationConstants.pushNumberOpcodesOffset */), 1];
    }
    else if (radix === 79 /* PushOperationConstants.OP_1NEGATE */) {
        return [Uint8Array.of(129 /* PushOperationConstants.negativeOne */), 1];
    }
    else {
        let len, start;
        if (radix === 76 /* PushOperationConstants.OP_PUSHDATA_1 */) {
            start = 2;
            len = binToNumberUintLE(data.slice(1, start));
        }
        else if (radix === 77 /* PushOperationConstants.OP_PUSHDATA_2 */) {
            start = 3;
            len = binToNumberUint16LE(data.slice(1, start));
        }
        else if (radix === 78 /* PushOperationConstants.OP_PUSHDATA_4 */) {
            start = 5;
            len = binToNumberUint32LE(data.slice(1, start));
        }
        else {
            start = 1;
            len = data[0];
        }
        const end = start + len;
        return [Uint8Array.from(data.slice(start, end)), end];
    }
}
export function encodePushByte(data) {
    if (typeof data === "string")
        data = hexToBin(data);
    if (data.length <= 75 /* PushOperationConstants.maximumPushByteOperationSize */) {
        if (data.length === 0) {
            return Uint8Array.of(0);
        }
        else {
            if (data.length === 1) {
                if (data[0] !== 0 && data[0] <= 16 /* PushOperationConstants.pushNumberOpcodes */) {
                    return Uint8Array.of(data[0] + 80 /* PushOperationConstants.pushNumberOpcodesOffset */);
                }
                else {
                    if (data[0] === 129 /* PushOperationConstants.negativeOne */) {
                        return Uint8Array.of(79 /* PushOperationConstants.OP_1NEGATE */);
                    }
                    else {
                        return Uint8Array.from([1, ...data]);
                    }
                    ;
                }
                ;
            }
            else {
                return Uint8Array.from([data.length, ...data]);
            }
            ;
        }
        ;
    }
    else {
        if (data.length <= 255 /* PushOperationConstants.maximumPushData1Size */) {
            return Uint8Array.from([
                76 /* PushOperationConstants.OP_PUSHDATA_1 */,
                data.length,
                ...data,
            ]);
        }
        else {
            if (data.length <= 65535 /* PushOperationConstants.maximumPushData2Size */) {
                return Uint8Array.from([
                    77 /* PushOperationConstants.OP_PUSHDATA_2 */,
                    ...numberToBinUint16LE(data.length),
                    ...data,
                ]);
            }
            else {
                return Uint8Array.from([
                    78 /* PushOperationConstants.OP_PUSHDATA_4 */,
                    ...numberToBinUint32LE(data.length),
                    ...data,
                ]);
                ;
            }
            ;
        }
        ;
    }
}
export function decodePushBytes(data) {
    if (typeof data === "string")
        data = hexToBin(data);
    let cursor = 0;
    let result = [];
    while (cursor < data.length) {
        const tmp = decodePushByte(data.slice(cursor));
        result.push(tmp[0]);
        cursor += tmp[1];
    }
    return result;
}
export function encodePushBytes(data) {
    const encodedChunks = data.map((d) => { return encodePushByte(d); });
    return catUint8(encodedChunks);
}
//# sourceMappingURL=encode.js.map